import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { THEME } from "../../constants/theme";

const TipHintWrapper = ({ children, hintKey, location }) => {
    const [showHint, setShowHint] = useState(false);
    const [hintContent, setHintContent] = useState("");
    const [hintConfig, setHintConfig] = useState(null);

    useEffect(() => {
        // Check if this hint was previously dismissed
        const storedConfigs = localStorage.getItem("tipConfigs");
        const configs = storedConfigs ? JSON.parse(storedConfigs) : [];
        const isDismissed = localStorage.getItem(`tip_${hintKey}_dismissed`);
        if (isDismissed) return;

        checkAndUpdateHint();
    }, [hintKey, location]);

    const checkAndUpdateHint = () => {
        const storedConfigs = localStorage.getItem("tipConfigs");
        const configs = storedConfigs ? JSON.parse(storedConfigs) : [];

        const config = configs?.find(
            (config) => config.key === hintKey && config.location === location && config.isActive
        );

        if (config) {
            setShowHint(true);
            setHintContent(config.content);
            setHintConfig(config);
        }
    };

    const closeHint = (e) => {
        e.stopPropagation();
        setShowHint(false);
        localStorage.setItem(`tip_${hintKey}_dismissed`, "true");
    };

    if (!showHint) {
        return children;
    }

    return (
        <div className="relative group">
            {children}
            <div
                className="absolute z-30 bg-zinc-600 text-zinc-200 px-3 py-2 rounded-md text-sm 
                           shadow-lg border border-zinc-400 whitespace-nowrap top-full mt-2 left-1/2 
                           transform -translate-x-1/2"
            >
                <button
                    onClick={closeHint}
                    className="absolute -top-1 -right-1 p-0.5 bg-zinc-700 rounded-full 
                             hover:bg-zinc-600 transition-colors"
                >
                    <X className="h-3 w-3" />
                </button>
                <div className="flex items-center gap-2">
                    {hintConfig?.iconUrl && (
                        <img src={hintConfig.iconUrl} alt="" className="w-4 h-4" />
                    )}
                    <span>{hintContent}</span>
                </div>
                {/* Arrow */}
                <div
                    className="absolute -top-2 left-1/2 -translate-x-1/2 border-8 border-transparent 
                              border-b-zinc-200 transform rotate-180"
                />
            </div>
        </div>
    );
};

export default TipHintWrapper;
